export default function clientListReducer(
    state: any = {
        loading: false,
        done: false,
        policyList: null,
        quoteList: null,
        error: null,
        success: null,
        updated: null,
    },
    action: any) {

    switch (action.type) {

        /**
         *     Tracker activity reducer
         */
        case 'FETCH_QUOTE_LIST_PENDING': {
            return { ...state, loading: true, success: null }
        }

        case 'FETCH_QUOTE_LIST_REJECTED': {
            return { ...state, loading: false, error: action.payload, success: false }
        }

        case 'FETCH_QUOTE_LIST_FULFILLED': {
            return {
                ...state, loading: false, done: true, error: null, quoteList: action.payload,
            }
        }

        /**
         *     Tracker activity reducer
         */
        case 'FETCH_POLICIES_LIST_PENDING': {
            return { ...state, loading: true, success: null }
        }

        case 'FETCH_POLICIES_LIST_REJECTED': {
            return { ...state, loading: false, error: action.payload, success: false }
        }

        case 'FETCH_POLICIES_LIST_FULFILLED': {
            return {
                ...state, loading: false, done: true, error: null, policyList: action.payload,
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/clientList.ts